<template>
  <div>
    <navigation-main bg="true" />

    <div class="main-content">
      <div class="" data-spy="scroll" data-target="#mainNav" data-offset="75">
        <main role="main" class="flex-grow-1 overflow-auto">
          <div id="content">
            <b-carousel
              id="carousel-fade"
              style="text-shadow: 0px 0px 2px #000"
              class="main-carousel"
              fade
              indicators
              img-width="1024"
            >
              <b-carousel-slide class="test" img-src="/imgs/GOPR0594_frame_001038_teaser.png">
                <div
                  class="row h-100 align-items-center justify-content-center text-center textbox-main"
                >
                  <div class="col-lg-10 align-self-end">
                    <h1 class="text-white font-weight-bold">
                      Winners of ACDC Challenge 2023 are announced
                    </h1>
                    <hr class="divider m-auto" />
                  </div>
                  <div class="col-lg-8 align-self-baseline">
                    <p class="text-white font-weight-light mb-5">
                      June 12, 2023
                    </p>
                    <a
                      class="btn btn-primary btn-xl js-scroll-trigger"
                      href="#challenge2023winners"
                      >Details</a
                    >
                  </div>
                </div>
              </b-carousel-slide>
              <b-carousel-slide class="test" img-src="/imgs/GP040176_frame_000464_teaser.png">
                <div
                  class="row h-100 align-items-center justify-content-center text-center textbox-main"
                >
                  <div class="col-lg-10 align-self-end">
                    <h1 class="text-white font-weight-bold">
                      ACDC Challenge 2023 is up
                    </h1>
                    <hr class="divider m-auto" />
                  </div>
                  <div class="col-lg-8 align-self-baseline">
                    <p class="text-white font-weight-light mb-5">
                      April 13, 2023
                    </p>
                    <a
                      class="btn btn-primary btn-xl js-scroll-trigger"
                      href="#challenge2023"
                      >Details</a
                    >
                  </div>
                </div>
              </b-carousel-slide>
              <b-carousel-slide img-src="/imgs/GP010477_frame_000127_teaser.png">
                <div
                  class="row h-100 align-items-center justify-content-center text-center textbox-main"
                >
                  <div class="col-lg-10 align-self-end">
                    <h1 class="text-white font-weight-bold">
                      Dataset released
                    </h1>
                    <hr class="divider m-auto" />
                  </div>
                  <div class="col-lg-8 align-self-baseline">
                    <p class="text-white font-weight-light mb-5">
                      April 29, 2021
                    </p>
                    <a
                      class="btn btn-primary btn-xl js-scroll-trigger"
                      href="#release"
                      >Details</a
                    >
                  </div>
                </div>
              </b-carousel-slide>
            </b-carousel>
            <!-- ACDC Challenge 2023 Winners-->
            <section class="page-section" id="challenge2023winners">
              <div class="container">
                <div class="row ">
                  <div class="col-lg-12">
                    <div>
                      <h2
                        class="text-black mt-0"
                        style="color:black !important;"
                      >
                        Winners of ACDC Challenge 2023 are announced - June 12, 2023
                      </h2>
                      <hr class="divider dark" style="max-width: 100%" />
                    </div>
                    <p>
                      The winning teams of the ACDC Challenge 2023 on semantic perception in adverse
                      visual conditions are the following:
                    </p>
                    <ol class="ml-3">
                      <li>
                        Normal-to-adverse domain adaptation of semantic segmentation on Cityscapes to ACDC: Jun Yu, Quansheng Liu, and Chengdao Pu,
                        from University of Science and Technology of China (USTC) 
                      </li>
                      <li>
                        Supervised semantic segmentation in adverse conditions: Jinming Su*, Wangwang Yang*, Junfeng Luo, and Xiaolin Wei,
                        from Meituan (*: equal contribution)
                      </li>
                      <li>
                        Normal-to-adverse domain adaptation of object detection on Cityscapes to ACDC: Xiaoqiang Lu, Licheng Jiao, Fang Liu, Xu Liu, and Lingling Li,
                        from Xidian University
                      </li>
                      <li>
                        Supervised panoptic segmentation in adverse conditions: Jinming Su*, Wangwang Yang*, Junfeng Luo, and Xiaolin Wei,
                        from Meituan (*: equal contribution)
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </section>
            <!-- ACDC Challenge 2023-->
            <section class="page-section" id="challenge2023">
              <div class="container">
                <div class="row ">
                  <div class="col-lg-12">
                    <div>
                      <h2
                        class="text-black mt-0"
                        style="color:black !important;"
                      >
                        ACDC Challenge 2023 is up - April 13, 2023
                      </h2>
                      <hr class="divider dark" style="max-width: 100%" />
                    </div>
                    <p>
                      The ACDC Challenge 2023 on semantic perception in adverse
                      visual conditions is organized in conjunction with the CVPR 2023 workshop
                      <a href="https://vision4allseason.net/">Vision for All Seasons</a>.
                      The challenge is based on the public ACDC
                      <a href="../benchmarks">benchmarks</a> and it will run until
                      June 7, 2023. It features five tracks:
                    </p>
                    <ol class="ml-3">
                      <li>
                        Normal-to-adverse domain adaptation of semantic segmentation on Cityscapes to ACDC
                      </li>
                      <li>
                        Supervised semantic segmentation in adverse conditions
                      </li>
                      <li>
                        Uncertainty-aware semantic segmentation
                      </li>
                      <li>
                        Normal-to-adverse domain adaptation of object detection on Cityscapes to ACDC
                      </li>
                      <li>
                        Supervised panoptic segmentation in adverse conditions
                      </li>
                    </ol>
                    <a
                      class="btn btn-secondary btn-xl js-scroll-trigger"
                      href="/other/ACDC_Challenge_2023-guidelines.pdf"
                      >Guidelines</a
                    >
                  </div>
                </div>
              </div>
            </section>
            <!-- ACDC Challenge 2022-->
            <section class="page-section" id="challenge2022">
              <div class="container">
                <div class="row ">
                  <div class="col-lg-12">
                    <div>
                      <h2
                        class="text-black mt-0"
                        style="color:black !important;"
                      >
                        ACDC Challenge 2022 is up - February 4, 2022
                      </h2>
                      <hr class="divider dark" style="max-width: 100%" />
                    </div>
                    <p>
                      The ACDC Challenge 2022 on semantic segmentation in adverse
                      visual conditions is organized in conjunction with the CVPR 2022 workshop
                      <a href="https://vision4allseason.net/">Vision for All Seasons</a>.
                      The challenge is based on the public ACDC
                      <a href="../benchmarks">benchmarks</a> and it will run until
                      June 3, 2022. It features four tracks:
                    </p>
                    <ol class="ml-3">
                      <li>
                        Normal-to-adverse domain adaptation on Cityscapes to ACDC
                      </li>
                      <li>
                        Supervised semantic segmentation in adverse conditions
                      </li>
                      <li>
                        Supervised semantic segmentation in individual adverse conditions
                      </li>
                      <li>
                        Uncertainty-aware semantic segmentation
                      </li>
                    </ol>
                    <a
                      class="btn btn-secondary btn-xl js-scroll-trigger"
                      href="/other/ACDC_Challenge_2022-guidelines.pdf"
                      >Guidelines</a
                    >
                  </div>
                </div>
              </div>
            </section>
				<!-- Dataset released-->
            <section class="page-section" id="release">
              <div class="container">
                <div class="row mt-3">
                  <div class="col-lg-12 mt-2">
                    <div>
                      <h2
                        class="text-black mt-0"
                        style="color:black !important;"
                      >
                        Dataset released - April 29, 2021
                      </h2>
                      <hr class="divider dark" style="max-width: 100%" />
                    </div>
                    <p class="mb-4">
                      ACDC, the Adverse Conditions Dataset with Correspondences,
                      is released.
                    </p>
                    <a
                      class="btn btn-secondary btn-xl js-scroll-trigger"
                      href="../download"
                      >Get Started!</a
                    >
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "../style/_variables.scss";
@import "../style/mixins.scss";

.carousel-item img {
  height: calc(100vh - 60px) !important;
  object-fit: cover !important;
  filter: blur(2px);
}

.textbox-main {
  background-color: #02000000;
}

.carousel-caption {
  bottom: 50% !important;
}
</style>
<script>
import { mapState } from "vuex";
import NavigationMain from "@/views/navigation/navigation-main";

export default {
  components: { NavigationMain },
  computed: {
    ...mapState({
      account: state => state.account
    })
  }
};
</script>
